import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app/store';

// Define a type for the slice state
interface AlbumsState {
    albums: any[];
    loading: boolean;
}

// Define the initial state using that type
// Initial value in explorer is used in /browse
const initialState: AlbumsState = {
    albums: [],
    loading: false,
}

export const albumsSlice = createSlice({
    name: 'albums',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        resetExplorerToInitialState: state => {
            state.albums = []
            state.loading = false
        },

        setAlbums: (state, action: PayloadAction<any[]>) => {
            state.albums = action.payload
        },
    }
})

export const {
    resetExplorerToInitialState,
    setAlbums,
} = albumsSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const spaceAlbums = (state: RootState) => state.albums.albums
export const isAlbumsLoading = (state: RootState) => state.albums.loading

export default albumsSlice.reducer